import { useRouter } from 'next/router';
import { useLang } from '@/i18n';
import EcoImg from 'eco-design-components/base/eco-img';
import EcoSpace from 'eco-design-components/base/eco-space';
import { useState } from 'react';
import css from './index.module.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper';
import { Swiper as SwiperType } from 'swiper/types';
import gtm from '@/utils/gtm';

interface ItemType {
    imgs: string[][];
    tab: string;
}
const D: React.FC = () => {
    const { locale = 'us' } = useRouter();
    const { t } = useLang('rapidpro');
    const [activeTab, setActiveTab] = useState(0);
    const [activeIdx, setActiveIdx] = useState(0);
    const [swiper, setSwiper] = useState({
        realIndex: 0,
        slideTo: (_: number) => {},
        slidePrev: () => {},
        slideNext: () => {},
    } as SwiperType);

    const items: ItemType[] = [
        {
            imgs: [
                [
                    'https://websiteoss.ecoflow.com/upload/image/1754981059745/4_1_1.jpg',
                    'https://websiteoss.ecoflow.com/upload/image/1754981059526/4_1_1_M.jpg',
                ],
                [
                    'https://websiteoss.ecoflow.com/upload/image/1754981060196/4_1_2.jpg',
                    'https://websiteoss.ecoflow.com/upload/image/1754981060745/4_1_2_M.jpg',
                ],
                [
                    'https://websiteoss.ecoflow.com/upload/image/1754981060955/4_1_3.jpg',
                    'https://websiteoss.ecoflow.com/upload/image/1754981059902/4_1_3_M.jpg',
                ],
            ],
            tab: t('D_tab1'),
        },
        {
            imgs: [
                [
                    'https://websiteoss.ecoflow.com/upload/image/1754981370691/4_2_1.jpg',
                    'https://websiteoss.ecoflow.com/upload/image/1754981369470/4_2_1_M.jpg',
                ],
                [
                    'https://websiteoss.ecoflow.com/upload/image/1754981370187/4_2_2.jpg',
                    'https://websiteoss.ecoflow.com/upload/image/1754981370393/4_2_2_M.jpg',
                ],
                [
                    'https://websiteoss.ecoflow.com/upload/image/1754981370897/4_2_3.jpg',
                    'https://websiteoss.ecoflow.com/upload/image/1754981371521/4_2_3_M.jpg',
                ],
            ],
            tab: t('D_tab2'),
        },
        {
            imgs: [
                [
                    'https://websiteoss.ecoflow.com/upload/image/1754981637362/4_3_1.jpg',
                    'https://websiteoss.ecoflow.com/upload/image/1754981638711/4_3_1_M.jpg',
                ],
                [
                    'https://websiteoss.ecoflow.com/upload/image/1754981638196/4_3_2.jpg',
                    'https://websiteoss.ecoflow.com/upload/image/1754981637776/4_3_2_M.jpg',
                ],
                [
                    'https://websiteoss.ecoflow.com/upload/image/1754981638468/4_3_3.jpg',
                    'https://websiteoss.ecoflow.com/upload/image/1754981637508/4_3_3_M.jpg',
                ],
            ],
            tab: t('D_tab3'),
        },
        {
            imgs: [
                [
                    'https://websiteoss.ecoflow.com/upload/image/1749008649967/4_4_1.jpg',
                    'https://websiteoss.ecoflow.com/upload/image/1749008649587/4_4_1_M.jpg',
                ],
                [
                    'https://websiteoss.ecoflow.com/upload/image/1749008650600/4_4_2.jpg',
                    'https://websiteoss.ecoflow.com/upload/image/1749008650429/4_4_2_M.jpg',
                ],
                [
                    'https://websiteoss.ecoflow.com/upload/image/1749008650237/4_4_3.jpg',
                    'https://websiteoss.ecoflow.com/upload/image/1749008649771/4_4_3_M.jpg',
                ],
            ],
            tab: t('D_tab4'),
        },
    ];

    const handleSlideChange = () => {
        setActiveIdx(swiper?.realIndex);
    };

    const handleChangeTab = (e: MouseEvent<HTMLLIElement, MouseEvent>, k: number) => {
        setActiveTab(k);
        // 滚动出这个tab
        const tab = e.target;
        tab?.scrollIntoView?.({ behavior: 'smooth', block: 'nearest', inline: 'center' });

        if (swiper) swiper.slideTo(0);
        gtm.push({
            event: 'uaEvent',
            event_name: 'tab_click',
            list_name: t('D_title'),
            button_name: items[k].tab,
        });
    };

    const handleGTM = (num: number) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'product_detail_page',
            list_name: t('D_title'),
            button_name: num === 1 ? 'Left switch' : num === 2 ? 'Right switch' : 'none',
        });
    };

    return (
        <div id="rapid-pro-D" className={`rapid-pro-D ${css.section}`}>
            <EcoSpace />
            <div className="info">
                <p className="info-title">{t('D_title')}</p>
            </div>
            <Swiper
                modules={[Navigation, Pagination]}
                className="swiper"
                spaceBetween={0}
                slidesPerView={'auto'}
                initialSlide={0}
                navigation={{
                    prevEl: `.rapid-pro-D .swiper-button-prev`,
                    nextEl: `.rapid-pro-D .swiper-button-next`,
                }}
                pagination={{
                    clickable: true,
                }}
                onSwiper={(swipwerIns: SwiperType) => setSwiper(swipwerIns)}
                // loop
                onSlideChange={handleSlideChange}
            >
                {items[activeTab].imgs.map((img: string[], k: number) => (
                    <SwiperSlide className={`swiper-item item-${k + 1}`} key={k}>
                        <EcoImg pc={img[0]} pad={img[0]} h5={img[1]} />
                    </SwiperSlide>
                ))}
                {items[activeTab].imgs?.length > 1 && (
                    <div className="swiper-button">
                        <button
                            className={`swiper-button-prev swiper-button-btn ${activeIdx <= 0 ? 'swiper-button-disabled' : ''}`}
                            onClick={() => handleGTM(1)}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="44" height="45" viewBox="0 0 44 45" fill="none">
                                <path
                                    d="M6.25977 0.719238L0.6875 6.60889V37.4536L6.25977 43.3442H37.0293L43.3125 37.4302V6.63232L37.0293 0.719238H6.25977Z"
                                    stroke="white"
                                    strokeWidth="1.375"
                                />
                                <mask id="path-2-inside-1_3127_21607_D1" fill="white">
                                    <path d="M17.4167 33.0317L28.4167 22.0317L17.4167 11.0317" />
                                </mask>
                                <path
                                    d="M18.389 34.004L17.4167 34.9763L15.4722 33.0317L16.4445 32.0595L18.389 34.004ZM28.4167 22.0317L29.389 21.0595C29.926 21.5964 29.926 22.467 29.389 23.004L28.4167 22.0317ZM16.4445 12.004L15.4722 11.0317L17.4167 9.08719L18.389 10.0595L16.4445 12.004ZM16.4445 32.0595L27.4445 21.0595L29.389 23.004L18.389 34.004L16.4445 32.0595ZM27.4445 23.004L16.4445 12.004L18.389 10.0595L29.389 21.0595L27.4445 23.004Z"
                                    fill="white"
                                    mask="url(#path-2-inside-1_3127_21607_D1)"
                                />
                            </svg>
                        </button>
                        <button
                            className={`swiper-button-next swiper-button-btn ${activeIdx >= items[activeTab].imgs.length - 1 ? 'swiper-button-disabled' : ''}`}
                            onClick={() => handleGTM(2)}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="44" height="45" viewBox="0 0 44 45" fill="none">
                                <path
                                    d="M6.25977 0.719238L0.6875 6.60889V37.4536L6.25977 43.3442H37.0293L43.3125 37.4302V6.63232L37.0293 0.719238H6.25977Z"
                                    stroke="white"
                                    strokeWidth="1.375"
                                />
                                <mask id="path-2-inside-1_3127_21607_D2" fill="white">
                                    <path d="M17.4167 33.0317L28.4167 22.0317L17.4167 11.0317" />
                                </mask>
                                <path
                                    d="M18.389 34.004L17.4167 34.9763L15.4722 33.0317L16.4445 32.0595L18.389 34.004ZM28.4167 22.0317L29.389 21.0595C29.926 21.5964 29.926 22.467 29.389 23.004L28.4167 22.0317ZM16.4445 12.004L15.4722 11.0317L17.4167 9.08719L18.389 10.0595L16.4445 12.004ZM16.4445 32.0595L27.4445 21.0595L29.389 23.004L18.389 34.004L16.4445 32.0595ZM27.4445 23.004L16.4445 12.004L18.389 10.0595L29.389 21.0595L27.4445 23.004Z"
                                    fill="white"
                                    mask="url(#path-2-inside-1_3127_21607_D2)"
                                />
                            </svg>
                        </button>
                    </div>
                )}
            </Swiper>
            <div className="tabs-content">
                <ul className="tabs">
                    {items.map((item: ItemType, k: number) => (
                        <li key={k} className={`tabs-tab${k === activeTab ? ' active' : ''}`} onClick={(e) => handleChangeTab(e, k)}>
                            {item.tab}
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default D;
